/* istanbul ignore file */
import React from 'react';

import { isSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { BackOfficeStore } from '@lumapps/redux/types';

import {
    GlobalAdministratorsSideNavigation as GlobalAdministratorsSideNavigationComponent,
    GlobalAdministratorsSideNavigationProps,
} from './GlobalAdministratorsSideNavigation';

type ConnectedGlobalAdministratorsSideNavigationProps = Omit<GlobalAdministratorsSideNavigationProps, 'isAllowed'>;

export const GlobalAdministratorsSideNavigation: React.FC<ConnectedGlobalAdministratorsSideNavigationProps> = (
    props,
) => {
    const isAllowed = useSelector((state: BackOfficeStore) => isSuperAdmin(state));

    return <GlobalAdministratorsSideNavigationComponent {...props} isAllowed={isAllowed} />;
};

GlobalAdministratorsSideNavigation.displayName = 'GlobalAdministratorsSideNavigationConnected';
